module.exports = __webpack_public_path__ + "static/media/jose-navas.bafc1317.jpg";